import * as Types from '../../declarations'
import SectionHeader from './components/SectionHeader'
import HTMLContent from 'components/HTMLContent'

interface Props {
	trip: Types.DB.Models.TripAttributes
}

const Permits = ({
	trip: {
		name,
		jsonData: { permits, trekOrClimb },
	},
}: Props) => {
	if (!permits) return <></>

	return (
		<div id="permits-wrapper" className="spacing-between-sections-above">
			<SectionHeader
				title={`${name} permits`}
				subtitle={`What permits are needed for ${
					trekOrClimb === Types.App.DataTypes.TrekOrClimb.TREK
						? 'treking'
						: 'climbing'
				} ${name}`}
				section={Types.App.DataTypes.FeedbackSection.PERMITS}
			/>
			{permits.description && (
				<HTMLContent
					id="permits-description"
					html={permits.description}
				></HTMLContent>
			)}

			{(permits?.permits ?? []).length > 0 && (
				<>
					{permits.permits.map((permit, permitIndex) => {
						return (
							<div key={permitIndex}>
								<h4>
									{permitIndex + 1}. {permit.name}
								</h4>
								<ul>
									<li>
										${permit.cost}{' '}
										{!!permit?.costLocal && (
											<>
												(~{permit.costLocal.toLocaleString()} in the local
												currency)
											</>
										)}
									</li>
									<li>{permit.description}</li>
									{(permit?.availability ?? '') !== '' && (
										<li>{permit.availability}</li>
									)}
								</ul>
							</div>
						)
					})}
				</>
			)}
		</div>
	)
}

export default Permits
